export default class CreateRateRequest {
    rateSourceId: string = '';
    rate: number = 0;
    fromDate: Date;
}
